import PropTypes from "prop-types";
import "../styles/LeftToEarnBox.css";
import Trophy from "../images/Trophy.svg";

const LeftToEarnBox = ({ promotionType, progress, cap, payout }) => {
  const countdownToCap = Math.max(0, cap - progress);

  const promotionConfig = {
    Quotes: {
      singular: "quote",
      plural: "quotes",
      action: "Quote",
    },
    Policies: {
      singular: "policy",
      plural: "policies",
      action: "Sell",
    },
  };

  const config = promotionConfig[promotionType] || promotionConfig.Policies;
  const itemText = countdownToCap === 1 ? config.singular : config.plural;
  const action = config.action;

  return (
    <div className="left-to-earn-box">
      <p className="left-to-earn-text">
        {countdownToCap > 0 ? (
          <>
            {action} <strong>{countdownToCap}</strong> more {itemText} to earn{" "}
            <strong>${payout}</strong>!
          </>
        ) : (
          <p>You've completed the promotion!</p>
        )}
      </p>
      <img src={Trophy} alt="Trophy" className="left-to-earn-icon" />
    </div>
  );
};

LeftToEarnBox.propTypes = {
  promotionType: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  cap: PropTypes.number.isRequired,
  payout: PropTypes.string.isRequired,
};

export default LeftToEarnBox;
